import { render, staticRenderFns } from "./TargetPrice.vue?vue&type=template&id=1a2fccb6&scoped=true"
import script from "./TargetPrice.vue?vue&type=script&lang=js"
export * from "./TargetPrice.vue?vue&type=script&lang=js"
import style0 from "./TargetPrice.vue?vue&type=style&index=0&id=1a2fccb6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a2fccb6",
  null
  
)

export default component.exports